import { FRAMEWORK_LABELS, STATUS_LABELS } from "@/lib/api";

const bandColor = (score) =>
  score >= 80 ? "#0369A1" : score >= 60 ? "#0F766E" : score >= 40 ? "#B45309" : "#BE123C";

export const ScoreGauge = ({ frameworkKey, data, compact = false }) => {
  const label = FRAMEWORK_LABELS[frameworkKey] || frameworkKey;
  if (!data) return null;

  if (!data.display_score) {
    return (
      <div className="border border-slate-200 bg-white p-5" data-testid={`score-card-${frameworkKey}`}>
        <p className="overline text-slate-400">{label}</p>
        <p className="mt-3 font-display text-lg font-bold text-slate-400">Not applicable</p>
        <p className="mt-2 text-xs leading-relaxed text-slate-500">{data.rationale}</p>
      </div>
    );
  }

  const size = compact ? 96 : 108;
  const stroke = compact ? 8 : 10;
  const r = (size - stroke) / 2;
  const circ = Math.PI * r;
  const pct = Math.max(0, Math.min(100, data.score));

  return (
    <div className="border border-slate-200 bg-white p-5" data-testid={`score-card-${frameworkKey}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="overline text-navy-800">{label}</p>
          {data.status === "limited" && (
            <span className="mt-2 inline-block border border-amber-200 bg-amber-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-700">
              Limited applicability
            </span>
          )}
        </div>
      </div>

      <div className="mt-3 flex items-center gap-4">
        <div className="relative shrink-0">
          <svg width={size} height={size / 2 + 6} viewBox={`0 0 ${size} ${size / 2 + 6}`}>
            <path
              d={`M ${stroke / 2} ${size / 2} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${size / 2}`}
              fill="none"
              stroke="#E2E8F0"
              strokeWidth={stroke}
            />
            <path
              d={`M ${stroke / 2} ${size / 2} A ${r} ${r} 0 0 1 ${size - stroke / 2} ${size / 2}`}
              fill="none"
              stroke={bandColor(pct)}
              strokeWidth={stroke}
              strokeDasharray={`${(pct / 100) * circ} ${circ}`}
              style={{ transition: "stroke-dasharray 700ms ease-out" }}
            />
          </svg>
          <span
            className={`absolute inset-x-0 bottom-1 text-center font-display font-extrabold text-navy-900 ${
              compact ? "text-lg" : "text-2xl"
            }`}
            data-testid={`score-value-${frameworkKey}`}
          >
            {pct}%
          </span>
        </div>
        <div>
          <p className="font-display text-sm font-bold text-navy-900" data-testid={`risk-band-${frameworkKey}`}>
            {data.risk_band}
          </p>
          <p className="mt-1 text-xs text-slate-500">
            {data.questions_scored}/{data.questions_total} questions scored
          </p>
          <p className="mt-1 text-[11px] text-slate-500">{STATUS_LABELS[data.status]}</p>
        </div>
      </div>
    </div>
  );
};
